module.exports = __webpack_public_path__ + "img/bulles_eau.9244ad96.jpg";